module.exports = __webpack_public_path__ + "img/miscelanea_flechita_negra.4713dee4.svg";